import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


export default class InitGsap {
	static init() {
		this.anmifadeup();
		this.navbarScroll();
	}


	static navbarScroll() {
		const navbar = document.querySelector( '.navbar' );
		if ( ! navbar ) return;

		ScrollTrigger.create( {
			start: 1,
			end: 99999,
			onEnter: () => navbar.classList.add( 'navbar-scrolled' ),
			onLeaveBack: () => navbar.classList.remove( 'navbar-scrolled' ),
		} );
	}

	static anmifadeup() {
		gsap.registerPlugin( ScrollTrigger );

		ScrollTrigger.defaults( {
			markers: false,
		} );

		ScrollTrigger.batch( '.anmi-fadeup', {
			onEnter: elements => {
				gsap.from( elements, {
					autoAlpha: 0,
					y: 60,
					stagger: 0.25,
				} );
			},
			once: true,
		} );


	}
}

